import React from 'react';

const DotRender: React.FC<{payload: any}> = ({payload}) => {
  return (
    <>
      <circle
        r={payload?.r * 1.5}
        stroke={payload?.fill}
        strokeWidth={payload?.strokeWidth * 2}
        fill={payload?.stroke}
        cx={payload?.cx}
        cy={payload?.cy}
      />
    </>
  );
};

export default DotRender;
